import React from "react";

type LabelProps = {
  id?: number;
  text: string;
  active?: boolean;
  onClickHandle?: (id: number) => void;
  isButton?: boolean;
  setValue;
  getValues;
};

const Label = ({
  id,
  active,
  text,
  isButton,
  getValues,
  setValue,
}: LabelProps) => {
  const handleClick = () => {
    const currentTags = getValues("tags") || [];
    let updatedTags;
    if (currentTags.includes(id)) {
      updatedTags = currentTags.filter((tag) => tag !== id);
    } else {
      updatedTags = [...currentTags, id];
    }
    setValue("tags", updatedTags);
  };
  const renderTag = () => {
    if (isButton) {
      return (
        <button
          key={id}
          type="button"
          className={`labelContainer ${active && "active"}`}
          onClick={handleClick}
        >
          {text}
        </button>
      );
    }
    return <div className="labelContainer active">{text}</div>;
  };

  return renderTag();
};
export default Label;
